<template>
  <component
    :is="componentName"
    :class="{
      'h-13 px-6 py-4': !isRaw && isSize('xl'),
      'h-12 px-10': !isRaw && isSize('lg'),
      'h-11 px-10': !isRaw && isSize('md'),
      'h-9 px-6': !isRaw && isSize('sm'),
      'h-8 px-3': !isRaw && isSize('xs'),
      'rounded-xl border border-primary bg-primary font-semibold text-white hover:border-primary hover:bg-white hover:text-primary':
        isPrimary,
      'rounded-xl border border-primary bg-white font-medium text-primary hover:bg-primary hover:text-white':
        isSecondary,
      'rounded-xl border border-gray-400 bg-transparent font-semibold text-primary hover:bg-secondary-300 hover:text-primary-400':
        isTertiary,
      'rounded-10 bg-accent font-semibold text-white hover:bg-accent/75 hover:text-white':
        isAccent,
      'text-primary hover:text-primary-400': isRaw,
      'w-full': isFullWidth,
      'animate-pulse cursor-not-allowed': loading,
      '!rounded-full !p-2': fab,
      uppercase: isUppercase,
      'shadow-secondary': hasShadow && isSecondary,
      'text-sm': (isSize('xs') || isSize('sm')) && !isRaw,
      'text-md': (isSize('md') || isSize('lg') || isSize('xl')) && !isRaw,
    }"
    class="group inline-flex items-center justify-center gap-2 truncate whitespace-nowrap transition duration-100 ease-linear disabled:border disabled:border-secondary-600 disabled:bg-secondary-200 disabled:text-gray-500"
    v-bind="{ to, ...(to && { raw: true }) }"
  >
    <slot
      :_class="{
        'size-10': isSize('xl'),
        'size-8': isSize('lg'),
        'size-6': isSize('md'),
        'size-4': isSize('sm'),
        'size-3': isSize('xs'),
        'size-2': isSize('4xs'),
      }"
      name="icon"
    />
    <slot />
    <slot
      :_class="{
        'size-10': isSize('xl'),
        'size-8': isSize('lg'),
        'size-6': isSize('md'),
        'size-4': isSize('sm'),
        'size-3': isSize('xs'),
        'size-2': isSize('4xs'),
      }"
      name="append-icon"
    />
    <slot v-if="badge !== undefined" :badge="badge" name="badge">
      <Transition
        appear
        enter-active-class="transition ease-linear duration-200"
        enter-to-class="opacity-100"
        leave-active-class="transition ease-linear duration-200"
        leave-to-class="opacity-0"
      >
        <span>({{ badge }})</span>
      </Transition>
    </slot>
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { ButtonVariant, Size, getSizeUtils } from '#storefront-ui'
import type { RouteLocationRaw } from '#vue-router'
import { SFLink } from '#storefront-ui/components'

const {
  variant = ButtonVariant.PRIMARY,
  size = Size.MD,
  to,
} = defineProps<{
  variant?: ButtonVariant
  size?: Size
  to?: RouteLocationRaw
  badge?: number
  isFullWidth?: boolean
  loading?: boolean
  fab?: boolean
  isUppercase?: boolean
  hasShadow?: boolean
}>()

const isPrimary = computed(() => variant === ButtonVariant.PRIMARY)
const isSecondary = computed(() => variant === ButtonVariant.SECONDARY)
const isTertiary = computed(() => variant === ButtonVariant.TERTIARY)
const isRaw = computed(() => variant === ButtonVariant.RAW)
const isAccent = computed(() => variant === ButtonVariant.ACCENT)

const { isSize } = getSizeUtils(size)

const componentName = computed(() => (to ? SFLink : 'button'))
</script>
